import { Box, Button, Dialog, DialogActions, DialogTitle, DialogContent, IconButton, DialogProps } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { styles } from './MoveItemsDialog.styles';
import { LocationSelect } from '../LocationSelect/LocationSelect';
import { Folder } from '../../types';
import { useParentFolder } from '../LocationSelect/hooks/useParentFolder';

const intl = {
  title: 'Move Items',
  cancel: 'Cancel',
  move: 'Move',
  closeIconAriaLabel: 'close button for dialog'
};

type MoveItemsDialogProps = DialogProps & {
  title?: string;
  isMoving?: boolean;
  checkFolderDepthLimit?: boolean;
  disabledFolderIds?: Folder['id'][];
  onClose: () => void;
  onMove: (parentFolderId: Folder['id']) => void;
};

export function MoveItemsDialog({
  title = intl.title,
  isMoving = false,
  disabledFolderIds,
  checkFolderDepthLimit = false,
  onMove,
  ...dialogProps
}: MoveItemsDialogProps) {
  const { parentFolder, subfolders, setParentFolderId } = useParentFolder();

  const handleMove = () => {
    onMove(parentFolder.id);
  };

  return (
    <Dialog fullWidth {...dialogProps}>
      <Box sx={styles.header}>
        <DialogTitle>{title}</DialogTitle>
        <IconButton sx={styles.closeIcon} aria-label={intl.closeIconAriaLabel} onClick={dialogProps.onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={styles.content}>
        {dialogProps.children}

        <LocationSelect
          withCreateNewFolder={true}
          checkDepthLimit={checkFolderDepthLimit}
          disabledFolderIds={disabledFolderIds}
          selectedFolder={parentFolder}
          subfolders={subfolders}
          onFolderSelect={setParentFolderId}
        />
      </DialogContent>

      <DialogActions>
        <Button disabled={isMoving} color="secondary" data-test="cancelMoveButton" onClick={dialogProps.onClose}>
          {intl.cancel}
        </Button>
        <LoadingButton
          loading={isMoving}
          color="primary"
          variant="contained"
          data-test="moveButton"
          onClick={handleMove}
        >
          {intl.move}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
